var _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 120,
    viewBox: "0 0 368 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 100,
    rx: 8,
    fill: "#FF6B35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 50,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 50,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 40,
    width: 30,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 70,
    r: 22,
    fill: "white",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 70 L 52 77 L 65 64",
    stroke: "#FF6B35",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#1F2937"
  }, "Contract")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 75,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#1F2937"
  }, "Lifecycle")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 105,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#1F2937"
  }, "Management")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClmLogo);
export default __webpack_public_path__ + "static/media/clm-logo.865ebb0ec8e81d13230147bca483422d.svg";
export { ForwardRef as ReactComponent };